export enum ToastMessage {
    SETTINGS_SAVED = 'Настройки сохранены',
}
